/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 6/12/2024
 */

import { HighlightOff } from '@mui/icons-material'
import { Button, IconButton, ImageList, ImageListItem, ImageListItemBar } from '@mui/material'
import React, { useContext, useState } from 'react'
import CheckoutContext from '../../Context/CheckoutContext';
import { SET_IMAGES } from '../../Pages/CheckoutPage';
import { convertFileToBase64 } from '../../Utils/Base64Converter'
import styles from "./ReqImageUploader.module.css";

const ReqImageUploader = () => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);

    const images = checkoutData.images

    const onImageUpload = async (e) => {
        let imagesArray = images
        for (let i = 0; i < e.target.files.length; i++) {
            const file = e.target.files[i];
            const base64 = await convertFileToBase64(file);
            imagesArray = [...imagesArray,
                {
                    image: base64,
                    dataType: file.type,
                    name: file.name,
                }
            ]
        }
        dispatch({ type: SET_IMAGES, payload: imagesArray})
    };

    const handleDeleteImage = async (e) => {
        const s = images.filter((item) => item !== e);
        dispatch({ type: SET_IMAGES, payload: s})
    };

    return (
        <div className={styles.container}>
            <ImageList className={styles.imgList} gap={5} cols={4} rowHeight={110}>
                {images?.length !== 0 &&
                images?.map((img, index) => (
                    <div key={index} className={styles.itemContainer}>
                        <ImageListItem>
                            <img
                                src={`${img.image}`}
                                alt=""
                                className={styles.image}
                                loading='lazy'
                            />
                            <ImageListItemBar
                                className={styles.imageBar}
                                position="top"
                                actionIcon={
                                    <IconButton
                                        className={styles.closeIcon}
                                        onClick={() => handleDeleteImage(img)}
                                    >
                                        <HighlightOff />
                                    </IconButton>
                                    }
                                actionPosition="right"
                            />
                        </ImageListItem>
                    </div>
                ))}
            </ImageList>
            <div>
                <label htmlFor="contained-button-file">
                    <div className={styles.buttonContainer}>
                        <form encType="multipart/form-data">
                            <Button
                                color="secondary"
                                variant="contained"
                                component="span"
                            >
                                Upload
                            <input
                                onChange={onImageUpload}
                                accept="image/*"
                                id="contained-button-file"
                                type="file"
                                hidden
                                multiple
                            />
                            </Button>
                        </form>
                    </div>
                </label>
            </div>
        </div>
    )
}

export default ReqImageUploader